"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderToString = renderToString;
var _mui = require("@ori-ui/mui");
var _server = _interopRequireDefault(require("react-dom/server"));
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Function will wrap the react element to theme provider and run renderToStaticMarkup
 * @param reactElement React.ReactElement
 * @returns string
 */
function renderToString(reactElement) {
  return _server.default.renderToStaticMarkup(/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.ThemeProvider, {
    children: reactElement
  }));
}
//# sourceMappingURL=renderToString.js.map